import { STORAGE_CDN_NAME, STORAGE_CDN_PATH, STORAGE_ELEMENT_BLOCK } from '../storage-constants';

export const CATALOG_BANNER_B = {
  banner: {
    alt: 'Баннер каталога готовых решений',
    srcLd: `${STORAGE_CDN_PATH}/banners/catalog-ld.jpg/catalog-ld-01.jpg`,
    srcD: `${STORAGE_CDN_PATH}/banners/catalog-ld.jpg/catalog-ld-01.jpg`,
    srcT: `${STORAGE_CDN_PATH}/banners/catalog-t.jpg/catalog-t.jpg`,
    src: `${STORAGE_CDN_PATH}/banners/catalog-m.jpg/catalog-m-01.jpg`,
  },
};

export const CATALOG_BANNER_C = {
  banner: {
    alt: 'Баннер каталога готовых решений',
    srcLd: `${STORAGE_CDN_PATH}/banners/c/catalog-ld.jpg/catalog-ld-01.jpg`,
    srcD: `${STORAGE_CDN_PATH}/banners/c/catalog-ld.jpg/catalog-ld-01.jpg`,
    srcT: `${STORAGE_CDN_PATH}/banners/c/catalog-t.jpg/catalog-t.jpg`,
    src: `${STORAGE_CDN_PATH}/banners/c/catalog-m.jpg/catalog-m-01.jpg`,
  },
};

export const CATALOG_BANNER = {
  href: 'https://storage.yandexcloud.net/lemanapro-ru-landings-docs/storage/LemanaPro_Storage_Catalog.pdf',
  title: 'Мебель для дома от Лемана ПРО',
  elementBlock: STORAGE_ELEMENT_BLOCK,
  elementName: 'Каталог готовых решений',
  promoName: `${STORAGE_ELEMENT_BLOCK}_top`,
};

export const SPLIT_BANNER = {
  banner: {
    alt: 'Баннер яндекс сплит',
    srcLd: `${STORAGE_CDN_PATH}/banners/split-ld.jpg/split-ld.jpg`,
    srcD: `${STORAGE_CDN_PATH}/banners/split-d.jpg/split-d.jpg`,
    srcT: `${STORAGE_CDN_PATH}/banners/split-t.jpg/split-t.jpg`,
    src: `${STORAGE_CDN_PATH}/banners/split-m.jpg/split-m.jpg`,
  },
  href: '/promo/split/',
  title: 'Специальное предложение - оплата Яндекс Сплит в Лемана Про',
  elementBlock: STORAGE_ELEMENT_BLOCK,
  elementName: 'Яндекс Сплит',
  promoName: `${STORAGE_ELEMENT_BLOCK}_bottom`,
};

export const INSPIRATION_GALLERY = [
  {
    alt: 'Интерьер №1',
    name: '1.jpg',
    gridSrc: `${STORAGE_CDN_PATH}/inspiration-gallery/1.jpg/1.jpg`,
    src: `${STORAGE_CDN_NAME}/inspiration-gallery/1.jpg/1.jpg`,
  },
  {
    alt: 'Интерьер №2',
    name: '2.jpg',
    gridSrc: `${STORAGE_CDN_PATH}/inspiration-gallery/2.jpg/2.jpg`,
    src: `${STORAGE_CDN_NAME}/inspiration-gallery/2.jpg/2.jpg`,
  },
  {
    alt: 'Интерьер №3',
    name: '3.jpg',
    gridSrc: `${STORAGE_CDN_PATH}/inspiration-gallery/3.jpg/3.jpg`,
    src: `${STORAGE_CDN_NAME}/inspiration-gallery/3.jpg/3.jpg`,
  },
  {
    alt: 'Интерьер №4',
    name: '4.jpg',
    gridSrc: `${STORAGE_CDN_PATH}/inspiration-gallery/4.jpg/4.jpg`,
    src: `${STORAGE_CDN_NAME}/inspiration-gallery/4.jpg/4.jpg`,
  },
];

export const MORE_STORAGE_B = [
  {
    href: '/catalogue/garderobnye-sistemy/',
    linkTitle: 'Гардеробные системы',
    imgAlt: 'Изображение гардеробной ситсемы',
    title: 'Гардеробные системы',
    srcD: `${STORAGE_CDN_PATH}/category-images/wardrobe-systems-d.jpg/wardrobe-systems-d.jpg`,
    srcT: `${STORAGE_CDN_PATH}/category-images/wardrobe-systems-t.jpg/wardrobe-systems-t.jpg`,
    src: `${STORAGE_CDN_PATH}/category-images/wardrobe-systems-m.jpg/wardrobe-systems-m.jpg`,
  },
  {
    href: '/catalogue/shkafy-kupe/',
    linkTitle: 'Шкафы-купе',
    imgAlt: 'Изображение шкафа с дверьми-купе',
    title: 'Двери-купе',
    srcD: `${STORAGE_CDN_PATH}/category-images/sliding-doors-d.jpg/sliding-doors-d.jpg`,
    srcT: `${STORAGE_CDN_PATH}/category-images/sliding-doors-t.jpg/sliding-doors-t.jpg`,
    src: `${STORAGE_CDN_PATH}/category-images/sliding-doors-m.jpg/sliding-doors-m.jpg`,
  },
  {
    href: '/catalogue/komody-i-tumby/',
    linkTitle: 'Комоды и тумбы',
    imgAlt: 'Изображение обувницы',
    title: 'Комоды и обувницы',
    srcD: `${STORAGE_CDN_PATH}/category-images/shoe-racks-d.jpg/shoe-racks-d.jpg`,
    srcT: `${STORAGE_CDN_PATH}/category-images/shoe-racks-t.jpg/shoe-racks-t.jpg`,
    src: `${STORAGE_CDN_PATH}/category-images/shoe-racks-m.jpg/shoe-racks-m.jpg`,
  },
];

export const MORE_STORAGE_C = [
  {
    href: '/catalogue/garderobnye-sistemy/',
    linkTitle: 'Гардеробные системы',
    imgAlt: 'Изображение гардеробной ситсемы',
    title: 'Гардеробные системы',
    srcD: `${STORAGE_CDN_PATH}/category-images/c/wardrobe-systems-d.jpg/wardrobe-systems-d.jpg`,
    srcT: `${STORAGE_CDN_PATH}/category-images/c/wardrobe-systems-t.jpg/wardrobe-systems-t.jpg`,
    src: `${STORAGE_CDN_PATH}/category-images/c/wardrobe-systems-m.jpg/wardrobe-systems-m.jpg`,
  },
  {
    href: '/catalogue/shkafy-kupe/',
    linkTitle: 'Шкафы-купе',
    imgAlt: 'Изображение шкафа с дверьми-купе',
    title: 'Двери-купе',
    srcD: `${STORAGE_CDN_PATH}/category-images/c/sliding-doors-d.jpg/sliding-doors-d.jpg`,
    srcT: `${STORAGE_CDN_PATH}/category-images/c/sliding-doors-t.jpg/sliding-doors-t.jpg`,
    src: `${STORAGE_CDN_PATH}/category-images/c/sliding-doors-m.jpg/sliding-doors-m.jpg`,
  },
  {
    href: '/catalogue/komody-i-tumby/',
    linkTitle: 'Комоды и тумбы',
    imgAlt: 'Изображение обувницы',
    title: 'Комоды и обувницы',
    srcD: `${STORAGE_CDN_PATH}/category-images/c/shoe-racks-d.jpg/shoe-racks-d.jpg`,
    srcT: `${STORAGE_CDN_PATH}/category-images/c/shoe-racks-t.jpg/shoe-racks-t.jpg`,
    src: `${STORAGE_CDN_PATH}/category-images/c/shoe-racks-m.jpg/shoe-racks-m.jpg`,
  },
];
